/**
 * Licensed Materials - Property of IBM IBM Cognos Products: BI Cloud (C)
 *
 * Copyright IBM Corp. 2016, 2020
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../lib/@waca/core-client/js/core-client/ui/core/View',
	'../../lib/@waca/dashboard-common/dist/ui/CenterLoadingSpinner',
	'./react_custom_widget/CustomWidgetGridView',
	'@ba/ba-ui-carbon-toolkit',
	'react',
	'react-dom',
	'underscore'
],
function(BaseView, CenterLoadingSpinner, CustomWidgetGridView, UI_CARBON_TOOLKIT, React, ReactDOM, _) {


	const keyNames = UI_CARBON_TOOLKIT.keyboardUtils.keyNames;

	const WidgetListView = BaseView.extend({
		events: {
			'mousedown .customWidgetTile': 'onItemStartDrag',
			'drag .customWidgetTile': 'onItemStartDrag'
		},

		init: function(options={}) {
			WidgetListView.inherited('init', this, arguments);
			this.options = options;
		},

		_getEntry(event){
			const target = this.getTarget(event.target, 'customWidgetTile');
			const dataId = target.getAttribute('data-id');
			// lookup with the id
			return this.widgetMap[dataId];
		},

		onItemClick(event){
			if (this.options.onItemClick){
				const entry = this._getEntry(event);
				this.options.onItemClick(entry, event);
				this._setDashboardApi(entry);
				if (event && event.gesture){
					event.gesture.preventDefault();
				}
			}
		},

		onItemStartDrag: function(ev){
			if (this.options.onItemStartDrag){
				var entry = this._getEntry(ev);
				this._setDashboardApi(entry);
				this.options.onItemStartDrag(entry, ev);
			}
		},

		onKeyDown(event) {
			if(event.key.toUpperCase() === keyNames.ENTER){
				this.onItemClick(event);
			}
		},

		_setDashboardApi(widgetEntry) {
			//always fetch the DashboardAPI from the current content view
			//TODO: pass the dashboardAPI from event handler inside CustomWidgetActionHandler.js
			if(!widgetEntry.options){
				widgetEntry.options = {};
			}
			widgetEntry.options.dashboardApi = this.options.glassContext.appController.getCurrentContentView().getDashboardApi();
		},

		/**
		 * Override to provide the list of all custom widgets
		 */
		getListItems: function() {
			return this.options.getEntries({ glassContext: this.options.glassContext })
				.then((content) => {
					if(Array.isArray(content.list)){
						content.list = content.list.filter( customWidget => !!customWidget && customWidget.id);
						this.list = content.list;
					} else {
						this.list = [];
					}

					// create the lookup map
					this.widgetMap = _.object(_.map(content.list, function(item) {
						return [item.id, item];
					}));

					return this.list;
				});
		},

		_renderSpinner(){
			const spinnerContainer = document.createElement('div');
			this.$el.append(spinnerContainer);
			const spinnerOptions = { variant: 'circle', size: 'normal' };
			ReactDOM.render(CenterLoadingSpinner(spinnerOptions), spinnerContainer);
			return this.getListItems().then(() => ReactDOM.unmountComponentAtNode(spinnerContainer));
		},

		render: function() {
			return this._renderSpinner().then(function() {
				return new Promise((resolve) => {
					ReactDOM.render( <CustomWidgetGridView customWidgets={this.list}
						onKeyDown={this.onKeyDown.bind(this)} handleClick={ (event) => this.onItemClick(event)}/>, this.$el[0], resolve );
				});
			}.bind(this));
		}
	});

	return WidgetListView;
});
